module.exports = __webpack_public_path__ + "img/contract_bg1.69a23d9e.png";